export default __webpack_public_path__ + "static/media/Snd_e6.687654e8.mp3";